module.exports = __webpack_public_path__ + "3e10000461ca0d1828425114dfa3341a.pdf";